module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Firmware-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-AddFirmware-Button",
      "id": "btn-firmware-form",
      "type": "warning"
    },
    on: {
      "click": _vm.showAddFirmware
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareButtonAddFirmwareText')) + "\n    ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "firmware-table",
    attrs: {
      "data": _vm.firmwareList,
      "default-sort": _vm.defaultSort,
      "element-loading-text": _vm.$t('firmwareTableLoadingText'),
      "data-qa": "Content-Firmware-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "firmware-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColVersionLabel'),
      "prop": "version",
      "sortable": "",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColPreviousVersionLabel'),
      "prop": "previousVersion",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColSHA1Label'),
      "prop": "sha1",
      "min-width": "320"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColModelLabel'),
      "prop": "model",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColSizeLabel'),
      "prop": "size",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColTriggerLabel'),
      "prop": "trigger",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": "true",
            "value": !!scope.row.trigger
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('firmwareTooltipDownloadText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('a', {
          staticClass: "el-button el-button--mini el-button--text",
          attrs: {
            "data-qa": ("Content-DownloadFirmware-Button-" + (scope.row.index)),
            "href": scope.row.url
          }
        }, [_c('i', {
          staticClass: "fa fa-download fa-2 operation-icons"
        })])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('firmwareTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteFirmware-Button-' + scope.row.index,
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.delFirmware(_vm.firmwareList[scope.row.index])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('firmware-delete'), _vm._v(" "), _c('firmware-upload')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c00632a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Firmware/Firmware.vue
// module id = 968
// module chunks = 3